module.exports = __webpack_public_path__ + "media/images/proof_links/facebook-c7c91a861ea6f8ea1924ffb4c0a7555a.svg";